export default __webpack_public_path__ + "static/media/UFO-im-Weltraum.e13bd183.png";